import { CustomSeriesOption, EChartsOption, graphic } from "echarts";
import goldBallImg from "@/assets/img/黄色小球2.png";

export const WAKE_LENGTH = 30; // 尾迹数量

export const chartWidth = 250;
export const chartHeight = 250;

export const arrowLength = 0.9;

export function calculateNewPosition(
  UIRx_BetaObs: number,
  radius = arrowLength
) {
  const angleInRadians = (UIRx_BetaObs * Math.PI) / 180; // 将角度转换为弧度
  const r = radius; // 固定半径为 0.7
  const x = r * Math.sin(angleInRadians);
  const y = r * Math.cos(angleInRadians);
  return [x, y] as [number, number];
}

const getCircle = (
  radius = 40,
  border = "#7ea39c",
  fill: any = "rgba(0,0,0,.0)"
) => {
  // radius 圆的半径
  return function (params: any, api: any) {
    const center = [chartWidth / 2, chartHeight / 2];
    const points = [];
    for (let i = 0; i < 360; i++) {
      const x = center[0] + radius * Math.cos((i * Math.PI) / 180);
      const y = center[1] + radius * Math.sin((i * Math.PI) / 180);
      points.push([x, y]);
    }
    const res = {
      type: "polygon",
      shape: {
        points: points,
      },
      style: {
        stroke: border, // 黑色边框
        lineWidth: 2, // 边框宽度为 1px
      },
    } as any;
    if (fill) res.style.fill = fill;
    return res;
  } as CustomSeriesOption;
};

export const getPoints = (datas: number[][]) => {
  // console.log(
  //   "[BOWEN_LOG] 🚀 ~~ getPoints ~~ datas:",
  //   JSON.parse(JSON.stringify(datas))
  // );
  const maxPointSize = 20;
  const minPointSize = 2;
  const maxOpacity = 1;
  const minOpacity = 0.1;
  // 最后一个最大随后递减变小变淡
  const points = datas.map(([x, y], index) => {
    const realIndex = datas.length - index - 1;
    const size =
      maxPointSize -
      (maxPointSize - minPointSize) * (realIndex / (datas.length - 1));
    const opacity =
      maxOpacity - (maxOpacity - minOpacity) * (realIndex / (datas.length - 1));
    // console.log("[BOWEN_LOG] 🚀 ~~ points ~~ size:", size);
    // console.log("[BOWEN_LOG] 🚀 ~~ points ~~ opacity:", opacity);
    // console.log("[BOWEN_LOG] 🚀 ~~ points ~~ x, y:", x, y);

    return {
      name: "TEST" + index,
      value: [x, y],
      z: index,
      zlevel: index,
      symbolSize: size,
      itemStyle: {
        opacity: opacity,
        color: realIndex === 0 ? "#ffd700" : "#607d8b",
        // realIndex === 0
        //   ? `rgba(255, 215, 0, ${opacity})`
        //   : `rgba(96, 125, 139, ${opacity})`,
      },
      symbol: realIndex === 0 ? `image://${goldBallImg}` : false,
    };
  });
  // points.reverse();
  // console.log("[BOWEN_LOG] 🚀 ~~ getPoints ~~ points:", points);
  return points;
};
export const getList = (datas: number[]) => {
  // const length = 8;
  // const max = length * 4;
  // const factor = max / length;
  // const list = datas.slice(-max).filter((_, index) => index % factor === 0);
  const list = datas.slice(-WAKE_LENGTH);
  return list;
};
export const getChartDefaulOpiotnsACC = () => {
  const showLine = false;
  const max = 0.9;
  const min = -0.9;
  // 获取图表容器的宽度和高度

  // 计算每单位长度对应的像素数
  const xUnitPixel = (chartWidth - 0) / (max - min);
  const yUnitPixel = (chartHeight - 0) / (max - min);

  // 假设你想画一个半径为 2 个单位长度的圆
  const radiusInPixel1 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.4); // 换算成像素
  const radiusInPixel2 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.7); // 换算成像素
  const radiusInPixel3 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.8); // 换算成像素
  // const radiusInPixel4 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 1.4); // 换算成像素

  const option = {
    backgroundColor: "#000",
    animation: false,
    grid: {
      top: 30,
      left: 30,
      right: 30,
      bottom: 30,
    },
    xAxis: {
      // name: "ax",
      min,
      max,
      axisLabel: {
        interval: 0.01,
        show: showLine,
      },
      splitLine: {
        show: showLine,
      },
      axisLine: {
        lineStyle: {
          color: "#7ea39c",
        },
      },
    },
    yAxis: {
      // name: "ay",
      min,
      max,
      axisLabel: {
        interval: 0.01,
        show: showLine,
      },
      splitLine: {
        show: showLine,
      },
      axisLine: {
        lineStyle: {
          color: "#7ea39c",
        },
      },
    },

    series: [
      {
        animation: false,
        symbolSize: 20,
        data: [[0, 0]],
        type: "scatter",
        z: 999,
        zlevel: 999,
        // clip: false,
        itemStyle: {
          opacity: 1,
          color: "#ffd700", // 基础颜色

          shadowBlur: 5,
          // shadowBlur: 5,
          // shadowOffsetX: 1.5,
          // shadowOffsetY: 3,
          // shadowColor: "rgba(255,255,255,.3)",

          // shadowColor: "#888888", // 阴影颜色
          // shadowBlur: 10, // 阴影模糊程度
          // shadowOffsetX: 5, // 阴影偏移量
          // shadowOffsetY: 5, // 阴影偏移量
        },
        symbol: `image://${goldBallImg}`,
        markPoint: {
          symbol: "circle",
          symbolSize: 5, // 圆的大小
          itemStyle: {
            color: "#7ea39c",
          },
          data: [{ name: "圆心", coord: ["0", "0"] }],
          zlevel: -1,
          z: -1,
        },
      },
      // 箭头
      {
        type: "graph",
        z: 10,
        symbolSize: 0,
        layout: "none",
        // layout: 'force', // 你可以选择其他布局，但这里的坐标将覆盖它
        coordinateSystem: "cartesian2d",
        label: {
          show: false,
        },
        edgeSymbol: ["circle", "triangle"],
        edgeSymbolSize: [10, 15],
        symbolOffset: [0, 0],
        // edgeLabel: {
        //   fontSize: 20,
        // },
        data: [
          {
            name: "Node 1",
            fixed: true,
            value: [0, 0],
            // symbolSize: 0,
          },
          {
            name: "Node 2",
            value: [0, arrowLength], // 箭头终点 随着数据改变
            // symbol: "arrow",
            // symbolSize: 20,
            // symbolOffset: [0, -10],
          },
        ],
        links: [
          {
            source: 0,
            target: 1,
            value: 1000,
            // symbol: ["circle", "none"],
            // symbolSize: [0, 15],
            label: {
              show: false,
            },
          },
        ],
        lineStyle: {
          opacity: 1,
          width: 6,
          curveness: 0,
          // color: {
          //   type: 'radial',
          //   x: 0.5,
          //   y: 0.5,
          //   r: 0.5,
          //   colorStops: [
          //     {
          //       offset: 0,
          //       color: '#ffffff', // 0% 处的颜色（中心）
          //     },
          //     {
          //       offset: 1,
          //       color: '#737577', // 100% 处的颜色（边缘）
          //     }
          //   ],
          //   global: false // 缺省为 false
          // },
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#ffffff", // 0% 处的颜色（中心）
              },
              {
                offset: 1,
                color: "#737577", // 100% 处的颜色（边缘）
              },
            ],
            // global: true, // 缺省为 false
          },
          cap: "round",
          join: "miter",
          miterLimit: 100,
        },
      },
      {
        type: "custom",
        renderItem: getCircle(radiusInPixel1, "rgba(126, 163, 156,.4)"),
        data: [[0, 0]], // 圆心位置
        // markLine: {
        //   symbol: ['none', "arrow"],
        //   symbolOffset: [[0, -10], [0, -10]],
        //   lineStyle: {
        //     color: "#ff0000",
        //     width: 2,
        //     type: "solid",
        //   },
        //   data: [
        //     {
        //       type: "average",
        //       name: "起点",
        //       // xAxis: 0.6,
        //       yAxis: 0,
        //       x: 100,
        //       y: 100,
        //       // x: 100,
        //       // y: 0,
        //       label: {
        //         show: false,
        //       },
        //       // end: [
        //       //   {
        //       //     // 终点坐标
        //       //     x: 200,
        //       //     y: 1150,
        //       //   },
        //       // ],
        //       // symbolRotate: 39, // 这里设置箭头与 Y 轴的夹角，单位为度
        //       // symbolRotate: 39, // 这里设置箭头与 Y 轴的夹角，单位为度
        //     },
        //     {
        //       type: "average",
        //       name: "终点",
        //       // symbol: "arrow",
        //       // symbolOffset: [0, -10],
        //       x: 0,
        //       y: 2,
        //       label: {
        //         show: false,
        //       },
        //       // symbolRotate: 39, // 这里设置箭头与 Y 轴的夹角，单位为度
        //     },
        //   ],
        // },
      },
      {
        type: "custom",
        renderItem: getCircle(radiusInPixel2, "rgba(126, 163, 156,.6)"),
        data: [[0, 0]], // 圆心位置
      },
      {
        type: "custom",
        renderItem: getCircle(
          radiusInPixel3,
          "rgba(126, 163, 156,1)",
          new graphic.RadialGradient(
            0.5, // 圆心 x 坐标
            0.5, // 圆心 y 坐标
            0.7, // 开始半径 (通常设为 0 表示从中心点开始)
            [
              { offset: 0, color: "rgba(0,0,0,0.4)" }, // 圆内颜色 (结束颜色)
              { offset: 1, color: "rgba(126, 163, 156,.5)" }, // 圆外颜色 (开始颜色)
            ]
          )
        ),
        data: [[0, 0]], // 圆心位置
      },
      // {
      //   type: "custom",
      //   renderItem: getCircle(radiusInPixel4, "rgba(126, 163, 156,.2)"),
      //   data: [[0, 0]], // 圆心位置
      // },
      // {
      //   type: "scatter",
      //   symbol: "none", // 隐藏标记点
      //   data: [0, 0],
      //   markPoint: {
      //     data: [
      //       {
      //         name: "圆心",
      //         coord: ["0", "0"],
      //         label: {
      //           show: true,
      //           position: [5, 0],
      //           formatter: "0.4", // 在圆的正上方显示数字
      //           color: "white",
      //           fontSize: 14,
      //           fontWeight: "bold",
      //         },
      //         itemStyle: {
      //           color: "transparent",
      //         },
      //       },
      //       {
      //         name: "圆心",
      //         coord: ["0", "0"],
      //         value: 200,
      //         label: {
      //           show: true,
      //           position: [5, 120],
      //           formatter: "0.8", // 在圆的正上方显示数字
      //           color: "white",
      //           fontSize: 14,
      //           fontWeight: "bold",
      //         },
      //         itemStyle: {
      //           color: "transparent",
      //         },
      //       },
      //     ],
      //   },
      // },
    ],
  } as EChartsOption;

  return option;
};
